var cpnbtn = document.getElementById("cpnbtn");
var cpnCode = document.getElementById("cpnCode");
var  copypastee = document.getElementById("copypastee");

   copypastee.onclick = function(){
     navigator.clipboard.writeText(cpnCode.innerHTML);
     cpnbtn.innerHTML = " copied ";
     setTimeout(function(){
       cpnbtn.innerHTML = " ";
     },20000);
   }